export enum PaymentTypeListType {
	Success = 'ACCEPT',
	Failed = 'DECLINE',
	CANCEL = 'CANCEL',
}